import React, { useState } from "react";
function Template() {
  const [value, setValue] = useState(4);
  return (
    <div className="container-goal">
      <input
        type="range"
        min="1"
        max="5"
        value={value}
        style={{ width: "10%" }}
        className="custom-range"
      />
      <h1 className="heading">Select a template</h1>
    </div>
  );
}

export default Template;
